export const MAIL_TIMER = 60000;
export const MAIL_SEND_DOC_SIZE_LIMIT = 10 * 1024 * 1024;
